import Link from "next/link";
import { inter } from "../fonts/inter";
import { motion } from "framer-motion";
import ContactBackground from "../components/background/ContactBackground";
import React from "react";

const Contact = () => {
  return (
    <motion.section
      className="relative z-10 flex w-full flex-col items-center justify-start overflow-x-hidden py-20 md:h-[80vh] md:justify-center md:py-20 lg:h-[90vh] lg:pt-0 lg:pb-28"
      id="contact"
      initial="initial"
      animate="animate"
    >
      <ContactBackground />

      <div
        className={`relative mx-auto flex w-[90%] flex-col items-center justify-center ${inter.className}`}
      >
        {/* Always-visible CONTACT heading */}
        <h1 className="w-full text-center text-[60px] font-extrabold uppercase leading-[0.9em] text-[#e4ded7] sm:text-[120px] md:text-[150px] lg:text-[120px] xl:text-[250px]">
          contact
        </h1>

        {/* Always-visible bottom row */}
        <div className="mt-8 flex w-full flex-col items-center justify-center gap-8 sm:mt-16 md:mt-12 md:flex-row md:items-start md:justify-between lg:mt-12 lg:max-w-[1440px]">
          {/* Question + email */}
          <div className="flex w-full max-w-[90%] flex-col items-center gap-3 text-center text-[14px] font-semibold uppercase text-[#e4ded7] sm:w-[350px] md:w-[310px] md:items-start md:text-left md:text-[16px] lg:w-[420px]">
            <p>Got a question, proposal, project, or want to work together on something?</p>
            <Link
              href="mailto:sahra.developer@gmail.com?subject=Lets%20work%20together!&body=Hello%2C%20I%20think%20we%20need%20you%20to%20work%20on%2Fcollaborate%20this%20particular%20product...%20Reach%20out%20as%20soon%20as%20you%20can."
              target="_blank"
              aria-label="Send me an email"
              className="underline underline-offset-2 hover:no-underline"
            >
              Send me an email →
            </Link>
          </div>

          {/* Social links */}
          <div className="flex gap-10 font-bold text-[#e4ded7] sm:gap-14 md:gap-10 lg:gap-20">
            <Link
              href="https://github.com/sahdibernardi"
              target="_blank"
              aria-label="View GitHub Profile"
              className="text-[16px] hover:underline sm:text-[20px] md:text-[16px] lg:text-[28px]"
            >
              GITHUB
            </Link>
            <Link
              href="https://www.linkedin.com/in/sahradibernardi/"
              target="_blank"
              aria-label="View LinkedIn Profile"
              className="text-[16px] hover:underline sm:text-[20px] md:text-[16px] lg:text-[28px]"
            >
              LINKEDIN
            </Link>
          </div>
        </div>
      </div>
    </motion.section>
  );
};

export default Contact;
